import { render, staticRenderFns } from "./LicenseAllocations.vue?vue&type=template&id=b49d4fd0"
import script from "./LicenseAllocations.vue?vue&type=script&lang=js"
export * from "./LicenseAllocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports